import { dateRangePickerDayClasses, pickersDayClasses } from "@mui/x-date-pickers-pro";
const borderRadius = '4px';
const MuiPickersDay = {
    styleOverrides: {
        root: ({ theme })=>({
                color: theme.palette.text.primary,
                borderRadius,
                width: '36px',
                height: '24px',
                [`&:not(.${dateRangePickerDayClasses.day})`]: {
                    margin: '2px !important',
                    transform: 'scale(1.1)'
                },
                '&:hover': {
                    backgroundColor: theme.palette.background.hover
                },
                [`&.${pickersDayClasses.dayOutsideMonth}`]: {
                    color: theme.palette.text.disabled
                },
                [`&.${pickersDayClasses.today}`]: {
                    borderColor: theme.palette.primary.main
                },
                [`&.${pickersDayClasses.selected}`]: {
                    background: theme.palette.primary.main
                }
            })
    }
};
export { MuiPickersDay };

//# sourceMappingURL=pickers-day-overrides.js.map